import Routers from "./Routers";
import { Provider } from "react-redux";
import store from "./store";
import { AppProvider, Frame } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import "@shopify/polaris/build/esm/styles.css";
function App() {
    return (
        <AppProvider i18n={enTranslations}>
            <Frame>
                <Provider store={store}>
                    <Routers />
                </Provider>
            </Frame>
        </AppProvider>
    );
}
export default App;
